<form [formGroup]="form" (ngSubmit)="submit()" class="gw-space-y-4 gw-p-1">
  <gatewee-select-v3
    [label]="'features.wallets.create.bindingMode' | translate"
    [items]="bindingModeItems"
    formControlName="bindingMode"
  ></gatewee-select-v3>

  <p class="gw-text-xs gw-text-text-secondary gw-m-0">
    {{
      (isStandaloneBinding
        ? 'features.wallets.create.bindingModeStandaloneHint'
        : 'features.wallets.create.bindingModePooledHint'
      ) | translate
    }}
  </p>

  <p *ngIf="loadingOptions" class="gw-text-sm gw-text-text-secondary gw-m-0">
    {{ 'common.loading' | translate }}...
  </p>

  <p *ngIf="loadError" class="gw-text-sm gw-text-status-negative gw-m-0">
    {{ loadError }}
  </p>

  <ng-container *ngIf="!loadingOptions && !loadError">
    <gatewee-select-v3
      *ngIf="isStandaloneBinding"
      [label]="'features.wallets.create.integration' | translate"
      [items]="integrationItems"
      [placeholder]="
        'features.wallets.create.integrationPlaceholder' | translate
      "
      formControlName="integrationId"
    ></gatewee-select-v3>

    <gatewee-select-v3
      *ngIf="!isStandaloneBinding"
      [label]="'features.wallets.create.pool' | translate"
      [items]="poolItems"
      [placeholder]="'features.wallets.create.poolPlaceholder' | translate"
      formControlName="poolId"
    ></gatewee-select-v3>

    <gatewee-input-v2
      [label]="'features.wallets.label' | translate"
      [placeholder]="'features.wallets.create.labelPlaceholder' | translate"
      [form]="form"
      controlName="label"
    ></gatewee-input-v2>

    <ng-container *ngIf="isStandaloneBinding">
      <div class="gw-grid gw-grid-cols-1 md:gw-grid-cols-2 gw-gap-4">
        <gatewee-input-v2
          [label]="'features.wallets.agency' | translate"
          [form]="form"
          controlName="agency"
        ></gatewee-input-v2>
        <gatewee-input-v2
          [label]="'features.wallets.account' | translate"
          [form]="form"
          controlName="account"
        ></gatewee-input-v2>
      </div>
      <gatewee-input-v2
        [label]="'features.wallets.create.ispb' | translate"
        [form]="form"
        controlName="ispb"
      ></gatewee-input-v2>
      <gatewee-input-v2
        [label]="'features.wallets.create.holderName' | translate"
        [form]="form"
        controlName="holderName"
      ></gatewee-input-v2>
    </ng-container>

    <gatewee-checkbox
      formControlName="isPrimary"
      [label]="'features.wallets.create.isPrimary' | translate"
    ></gatewee-checkbox>
  </ng-container>

  <div class="gw-flex gw-justify-end gw-gap-3 gw-pt-2">
    <gatewee-button
      type="button"
      variant="secondary"
      [title]="'common.actions.cancel' | translate"
      (clicked)="cancel()"
    ></gatewee-button>
    <gatewee-button
      type="submit"
      variant="primary"
      [title]="'features.wallets.create.submit' | translate"
      [disabled]="submitting || loadingOptions || !!loadError || form.invalid"
    ></gatewee-button>
  </div>
</form>
